import { render } from "./PlatformSectionsTable.vue?vue&type=template&id=64dcc4e6&scoped=true"
import script from "./PlatformSectionsTable.vue?vue&type=script&lang=js"
export * from "./PlatformSectionsTable.vue?vue&type=script&lang=js"

import "./PlatformSectionsTable.vue?vue&type=style&index=0&id=64dcc4e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dcc4e6"]])

export default __exports__